import axios from "axios"
import config from "../config"
import Vue from "vue";
const moduleStore = {
  state: {
    userList: [],
  },
  mutations: {},
  actions: {
    async getFloatingBannerList(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/getFloatingBannerList`, data)

          if (!result.data.errorCode || result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    async getFloatingBannerDetail(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/getFloatingBannerDetail`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    async createFloatingBanner(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/createFloatingBanner`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    async updateFloatingBanner(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/updateFloatingBanner`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {

          reject(err)
        }
      })
    },
    async deleteFloatingBanner(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/deleteFloatingBanner`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {

          reject(err)
        }
      })
    },
  },
  getters: {}
}

export default moduleStore;